export default __webpack_public_path__ + "static/media/dog.49a20f8d.jpg";